
import React from 'react'

export const Spinner = () => <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

export default Spinner
